export const getApiErrorMappings = (t) => ({
  shipment_number: { 'value is not unique': t('delivery.validation.shipmentNumberAlreadyRegistered') },
  vendor_id: { 'value not allowed': '\u200B' },
})

export const getApiErrorMappingMessages = (t) => ({
  vendor_id: { 'value not allowed': t('delivery.alert.vendorCannotBeScheduled') },
})
